(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_hogare-inline-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    function initHogareInlineCta(cta) {
      if (cta.dataset.hogareInlineCtaReady) return;
      cta.dataset.hogareInlineCtaReady = 'true';

      var label = cta.querySelector('.hogare-inline-cta__main');
      var originalLabel = label ? label.textContent : '';
      var waiting = false;

      // Releasit's button can attach a beat after this one is clickable. Rather than doing
      // nothing when it's not there yet, retry briefly and show "Cargando…" meanwhile, so a
      // slow-loading script reads as "wait a second" instead of "this is broken".
      function retry(attemptsLeft) {
        var realButton = document.querySelector('#rsi_buy_now_button');
        if (realButton) {
          waiting = false;
          cta.disabled = false;
          if (label) label.textContent = originalLabel;
          realButton.click();
          return;
        }
        if (attemptsLeft > 0) {
          setTimeout(function () {
            retry(attemptsLeft - 1);
          }, 300);
          return;
        }
        waiting = false;
        cta.disabled = false;
        if (label) label.textContent = originalLabel;
      }

      cta.addEventListener('click', function () {
        if (waiting) return;
        var realButton = document.querySelector('#rsi_buy_now_button');
        if (realButton) {
          realButton.click();
          return;
        }
        waiting = true;
        cta.disabled = true;
        if (label) label.textContent = 'Cargando…';
        retry(5);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-hogare-inline-cta]').forEach(initHogareInlineCta);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
